/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from '@angular/core';

export enum OBLIGATION_LABELS {
    monthly12 = 'Engagement 12 mois',
    monthly24 = 'Engagement 24 mois',
    none = 'Sans engagement',
}

export enum OBLIGATION_LABELS_YEAR {
    monthly12 = 'Engagement 1 an',
    monthly24 = 'Engagement 2 ans',
    none = 'Sans engagement',
}

export enum OBLIGATION_LABELS_OPTIONS {
    monthly12 = 'Abonnement 12 mois',
    monthly24 = 'Abonnement 24 mois',
    none = 'Sans engagement',
}

@Pipe({
    name: 'obligationLabel',
    pure: true,
    standalone: true,
})
export class ObligationPipe implements PipeTransform {
    transform(value: string, isOption: boolean = false, inYears: boolean = false): string {
        if (isOption) {
            return OBLIGATION_LABELS_OPTIONS[value] || OBLIGATION_LABELS_OPTIONS.none;
        }
        if (inYears) {
            return OBLIGATION_LABELS_YEAR[value] || OBLIGATION_LABELS_YEAR.none;
        }
        return OBLIGATION_LABELS[value] || OBLIGATION_LABELS.none;
    }
}
